import { render, staticRenderFns } from "./MobileAppList.vue?vue&type=template&id=4fa61444"
import script from "./MobileAppList.vue?vue&type=script&lang=ts"
export * from "./MobileAppList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports